import React from "react"
import classnames from "classnames"
import styles from "./LoadingSection.less"
import { LoadingIcon } from "AtomicComponents"

class LoadingSection extends React.PureComponent {
  render() {
    const { visible, height, styleName="light" } = this.props
    return (
      <div
        ref={c => this.loading = c}
        className={classnames({
          [styles.LoadingSection]: true,
          [styles.LoadingSectionHide]: !visible
        })}
        style={{
            height: height && height < 35 && height > 10 ? `${height}px`:"100%"
        }}>
        <LoadingIcon
          styleName={styleName}
          style={{
            width: height && height < 35 && height > 10 ? `${height}px`:"35px",
            height: height && height < 35 && height > 10 ? `${height}px`:"35px",
            flexShrink: 0
          }} />
      </div>
    )
  }
}


export default LoadingSection



// WEBPACK FOOTER //
// ./src/AtomicComponents/LoadingSection/LoadingSection.jsx